





























































import { Vue, Component, Prop } from 'vue-property-decorator'
import PopupState from './popup-state.vue'
import appUpdown from './appUpdown'
interface info {
    applicant: string,
    type: string,
    typeId: number,
    status: string,
    statusId: number
  }
@Component({
  name: 'PopupAppUpdown',
  components: {
    PopupState
  }
})
export default class extends Vue {
  @Prop({ required: true })
  info!: info

  appUpdown = Object.freeze(appUpdown)

  get text() {
    return (this.info && this.info.typeId === 2) ? '上架' : '下架'
  }
}
